import { Component } from "@theme/component";

/**
 *
 * @typedef {object} Refs
 * @property {HTMLInputElement} inputRef - The input element.
 *
 * @extends {Component<Refs>}
 */

class CustomInput extends Component {
  requiredRefs = ["inputRef"];

  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  //@ts-ignore
  handleInput(event) {
    if (event.target.type === "tel") {
      event.target.value = event.target.value.replace(/[^\d]/g, "");
    }
  }
}

if (!customElements.get("custom-input")) {
  customElements.define("custom-input", CustomInput);
}
